import './popup.css'
export default {

  alert: function (msg, time) {
    time = time || 2 * 1000
    let _dc = document.getElementById('popupContent')
    let _ds = document.getElementById('PubPopupStatus')
    _ds.style.display = 'block'
    _dc.firstElementChild.innerText = msg
    document.body.style.overflow = 'hidden'
    setTimeout(function () {
      _ds.style.display = 'none'
      document.body.style.overflow = 'auto'
    }, time)
  },
  hide: function () {
    let _ds = document.getElementById('PubPopupStatus')
    _ds.style.display = 'none'
    document.body.style.overflow = 'auto'
  }
}



// WEBPACK FOOTER //
// ./src/utils/popup/index.js